// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "::v-deep .video-search{width:100%}", "",{"version":3,"sources":["webpack://./app/themes/litea-timber/assets/js/lib/page/PageVideos.vue"],"names":[],"mappings":"AACE,uBACE,UAAJ","sourcesContent":["\n  ::v-deep .video-search {\n    width: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
